export class MathLabelRenderer {
  private static symbolMap: Record<string, string> = {
    '\\angle': '∠',
    '\\triangle': '△',
    '\\theta': 'θ',
    '\\pi': 'π',
    '\\alpha': 'α',
    '\\beta': 'β',
    '\\gamma': 'γ',
    '\\perp': '⊥',
    '\\parallel': '∥',
    '\\circ': '°',
    '^\\circ': '°',
    '\\deg': '°',
    '\\sqrt{3}': '√3',
    '\\sqrt{2}': '√2',
    '\\cdot': '·',
    '\\approx': '≈',
    '\\neq': '≠',
    '\\le': '≤',
    '\\ge': '≥',
  };

  /**
   * Converts LaTeX math notation string into unicode math text
   * e.g. "\angle ABC = 90^\circ" => "∠ ABC = 90°"
   */
  public static format(latexText: string): string {
    if (!latexText) return '';
    let result = latexText;

    for (const [key, val] of Object.entries(MathLabelRenderer.symbolMap)) {
      result = result.replaceAll(key, val);
    }

    // Clean up curly braces around superscripts e.g. 90^{\circ} => 90°
    result = result.replace(/\^{?\\circ}?/g, '°');
    result = result.replace(/\^{?([0-9]+)}?/g, '^$1');

    return result;
  }
}
